@if (!busy) {
  <div class="wm-l-newtest-container">
    @if (data.editMode) {
      <div class="wm-l-newtest-section">
        <div class="wm-l-newtest-section-desc">
          <div class="wm-l-newtest-section-title">Test Description</div>
          <div class="wm-l-newtest-section-subtitle">The name and description of the test.</div>
        </div>
        <div class="wm-l-newtest-section-content">
          <div class="wm-newtest-label">
            Name
          </div>
          <div class="wm-newtest-value">
            <div class="wm-newtest-input-line">
              <input type="text" pInputText [(ngModel)]="name"/>
              <div class="wm-newtest-input-icon">
                @if (nameInvalid()) {
                  <fa-icon aria-hidden="true" [pTooltip]="name.length > 0 ? 'Name already exists' : 'Name must not be empty'" tooltipZIndex="10000" icon="exclamation-triangle" size="lg" class="error-icon"></fa-icon>
                }
              </div>
            </div>
          </div>
          <div class="wm-newtest-label">
            Description
          </div>
          <div class="wm-newtest-value">
            <div class="wm-newtest-input-line">
              <input type="text" pInputText [(ngModel)]="description"/>
              <div class="wm-newtest-input-icon">
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="wm-l-newtest-section">
      <div class="wm-l-newtest-section-desc">
        <div class="wm-l-newtest-section-title">URL List</div>
        <div class="wm-l-newtest-section-subtitle">Specify a list of URL pairs. Each pair represents a reference and a new version of the same site</div>
      </div>
      <div class="wm-l-newtest-section-content">
        <div class="wm-m-newtest-urls">
          @for (url of urls; track trackByIndex(idx, url); let idx = $index) {
            <div class="url-entry" [ngClass]="{'divider': urls.length > 1 && idx < urls.length - 1}">
              <div class="url-input">
                <input type="text" pInputText placeholder="Reference URL {{idx + 1}}" [(ngModel)]="urls[idx]" (ngModelChange)="updateBaUrlOptions()" data-testing-id="new-crossbrowsertest-url-input" id="new-crossbrowsertest-url-input-{{idx}}">
                @if (!existingURLValid(idx)) {
                  <div class="url-validate-icon">
                    <fa-icon aria-hidden="true" [pTooltip]="'URL is not valid'" [tooltipZIndex]="10000" icon="exclamation-triangle" size="lg" class="error-icon"></fa-icon>
                  </div>
                }
                @if (existingURLValid(idx)) {
                  <div aria-hidden="true" class="url-validate-icon"></div>
                }
              </div>
              <div class="url-input">
                <input type="text" pInputText placeholder="Compare URL {{idx + 1}}" [(ngModel)]="crossUrls[idx]" (ngModelChange)="updateBaUrlOptions()" data-testing-id="new-crossbrowsertest-url-input" id="new-crossbrowsertest-url-cross-input-{{idx}}">
                @if (!existingCrossURLValid(idx)) {
                  <div class="url-validate-icon">
                    <fa-icon aria-hidden="true" [pTooltip]="'URL is not valid'" [tooltipZIndex]="10000" icon="exclamation-triangle" size="lg" class="error-icon"></fa-icon>
                  </div>
                }
                @if (existingCrossURLValid(idx)) {
                  <div aria-hidden="true" class="url-validate-icon"></div>
                }
              </div>
              @if (urls.length > 1) {
                <div class="url-controls" (click)="removeUrlListItem(idx)">Remove URL Pair</div>
              }
            </div>
          }
          <div class="url-add-btn">
            <button pButton (click)="addUrlListItem()" [disabled]="!mayAddNewUrlPair()" color="accent" label="Add URL" class="ui-button-secondary">
              <fa-icon icon="plus"></fa-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="wm-l-newtest-section" data-testing-id="reference-section">
      <div class="wm-l-newtest-section-desc">
        <div class="wm-l-newtest-section-title">Browser</div>
        <div class="wm-l-newtest-section-subtitle">Please select the browser that should be used to compare the versions of your site</div>
      </div>
      <div class="wm-l-newtest-section-content">
        <div class="reference-browsers">
          <div class="reference-browser-chooser" [ngClass]="{'full': !simplifiedRef}">
            @if (simplifiedRef) {
              <wm-browserchooser (browserChosen)="setReferenceBrowser($event)" [browsers]="availableReferenceBrowsers" [simpleMode]="true" [deployedBrowsers]="deployedBrowsers"
                                 [initWithBrowser]="chosenReferenceBrowser" [clear]="clearBrowser" [filterLocale]="true" class="wm-m-newtest-refbrowser"></wm-browserchooser>
            }
            @if (!simplifiedRef) {
              <wm-browserchooser (browserChosen)="setReferenceBrowser($event)" [browsers]="availableBrowsers" [deployedBrowsers]="deployedBrowsers"
                                 [initWithBrowser]="chosenReferenceBrowser" [clear]="clearBrowser" [filterLocale]="true" class="wm-m-newtest-refbrowser"></wm-browserchooser>
            }
          </div>
          @if (chosenReferenceBrowser && simplifiedRef) {
            <div class="reference-browser-info">
              <div>
                <strong>Version: </strong>{{ chosenReferenceBrowser.version }}
              </div>
              <div>
                <strong>Platform: </strong> {{ chosenReferenceBrowser.platform.getFullName() }}
              </div>
            </div>
          }
        </div>
        <div class="reference-browser-toggle-container">
          <div class="reference-browser-toggle" data-testing-id="new-crossbrowsertest-open-advanced-reference" (click)="toggleRef()">
            Show @if (simplifiedRef) {
            <span>advanced</span>
          }
            @if (!simplifiedRef) {
              <span>simple</span>
            } selection
          </div>
        </div>
      </div>
    </div>
    <div class="wm-l-newtest-advanced-toggle">
      <span (click)="toggleAdvancedSettings()">
        @if (!advancedSettingsShown) {
          <span>Show</span>
        }
        @if (advancedSettingsShown) {
          <span>Hide</span>
        }
        advanced settings
        @if (!advancedSettingsShown) {
          <fa-icon icon="caret-down"></fa-icon>
        }
        @if (advancedSettingsShown) {
          <fa-icon icon="caret-up"></fa-icon>
        }
      </span>
    </div>
    @if (advancedSettingsShown) {
      <div class="wm-l-newtest-section">
        <div class="wm-l-newtest-section-desc">
          <div class="wm-l-newtest-section-title">Advanced Settings</div>
          <div class="wm-l-newtest-section-subtitle">Configure additional aspects of your test, e.g. custom name or authentication data.</div>
        </div>
        <div class="wm-l-newtest-section-content">
          <p-accordion>
            <p-accordion-panel value="0" class="wm-newtest-expansion-panel">
              <p-accordion-header>Pre-Test Steps</p-accordion-header>
              <p-accordion-content>

                <div class="wm-m-newtest-settings-row">
                  Provide a set of URLs and XPaths that are visited and clicked on before running the test. This is useful for accepting or declining e.g. cookie policy notifications.
                </div>
                @for (clickdriver of clickDriverConfig; track trackByIndex(clickdriverId, clickdriver); let clickdriverId = $index) {
                  <div class="wm-m-newtest-settings-row wm-newtest-settings-driverconfigs">
                    @if (!clickdriverValid(clickDriverConfig[clickdriverId])) {
                      <div class="wm-newtest-settings-driverconfigs-validation" [pTooltip]="'Step is incomplete.'" [tooltipZIndex]="10000">
                        <fa-icon aria-hidden="true" icon="exclamation-triangle" size="lg" class="error-icon"></fa-icon>
                      </div>
                    }
                    @if (clickdriverValid(clickDriverConfig[clickdriverId])) {
                      <div class="wm-newtest-settings-driverconfigs-validation">
                        <fa-icon aria-hidden="true" icon="check" size="lg" class="success-icon"></fa-icon>
                      </div>
                    }
                    <div class="wm-newtest-settings-driverconfigs-url">
                      <div class="p-inputgroup">
                        <input [(ngModel)]="clickDriverConfig[clickdriverId].url" pInputText placeholder="URL">
                        <button pButton type="button" (click)="removeClickDriverConfig(clickdriverId)" icon="true">
                          <fa-icon icon="trash"></fa-icon>
                        </button>
                      </div>
                    </div>
                    <div class="wm-newtest-settings-driverconfigs-xpaths">
                      @for (xpath of clickdriver.xpaths; track trackByIndex(xPathId, xpath); let xPathId = $index) {
                        <div class="wm-newtest-settings-driverconfigs-xpaths-xpath">
                          <div class="p-inputgroup">
                            <input [(ngModel)]="clickDriverConfig[clickdriverId].xpaths[xPathId]" pInputText placeholder="XPath">
                            <button pButton type="button" (click)="removeXpathFromClickDriverConfig(clickdriverId, xPathId)" [disabled]="clickDriverConfig[clickdriverId].xpaths.length <= 1" icon="true">
                              <fa-icon icon="trash"></fa-icon>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                    <button pButton (click)="addXpathToClickdriverURL(clickdriverId)" color="accent" label="Add XPath" class="ui-button-secondary wm-newtest-settings-driverconfigs-addxpath">
                      <fa-icon icon="plus"></fa-icon>
                    </button>
                  </div>
                }
                <div class="wm-m-newtest-settings-row">
                  <button pButton (click)="addUrlToClickdriver()" [disabled]="!clickdriversValid()" color="accent" label="Add Step" class="ui-button-secondary wm-newtest-settings-driverconfigs-addurl">
                    <fa-icon icon="plus"></fa-icon>
                  </button>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="1" class="wm-newtest-expansion-panel">
              <p-accordion-header>Browser Automation</p-accordion-header>
              <p-accordion-content>
                <div class="wm-m-newtest-settings-row">
                  Configure automation helpers that run on the reference browser expedition before comparison begins.
                </div>
                <div class="wm-m-newtest-settings-editor">
                  <wm-automation-policy-editor [(ngModel)]="referenceAutomationPolicy"></wm-automation-policy-editor>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="2" class="wm-newtest-expansion-panel">
              <p-accordion-header>Basic Auth Data</p-accordion-header>
              <p-accordion-content>

                <div class="wm-m-newtest-settings-row">
                  Provide basic auth credentials for one or more domains used in the test
                </div>
                @if (browserWithoutBasicAuthSelected) {
                  <div class="wm-m-newtest-settings-row wm-newtest-settings-basicauth-error">
                    {{ basicAuthErrorMessage }}
                  </div>
                }
                @for (ba of basicAuthData; track ba; let i = $index) {
                  <div>
                    @if (basicAuthData.length > 1) {
                      <div class="ba-divider">
                        <fa-icon icon="trash" (click)="removeBAConfig(i)" [pTooltip]="'Remove Basic Auth Config'" [tooltipZIndex]="'99999'"></fa-icon>
                        <span></span>
                      </div>
                    }
                    <div class="wm-m-newtest-settings-row">
                      <p-select #dropdown emptyMessage="All domains set" [ngModel]="null" [options]="baUrlOptions" (onChange)="selectBaUrl($event, i); dropdown.value = null;" placeholder="Select Domain"></p-select>
                      @for (d of ba.urls; track d; let j = $index) {
                        <div class="ba-domain-entry">
                          <span>{{ d }}</span>
                          <fa-icon icon="times" (click)="removeBaUrl(i, j)"></fa-icon>
                        </div>
                      }
                    </div>
                    <div class="wm-m-newtest-settings-row">
                      <div class="wm-m-newtest-settings-input full">
                        <input [(ngModel)]="ba.username" pInputText placeholder="Username">
                      </div>
                    </div>
                    <div class="wm-m-newtest-settings-row">
                      <div class="wm-m-newtest-settings-input full">
                        <p-password [(ngModel)]="ba.password" [feedback]="false" [style]="{width :'100%'}" placeholder="Password"></p-password>
                      </div>
                    </div>
                  </div>
                }
                <div class="wm-m-newtest-settings-row">
                  <button pButton (click)="addBAConfig()" [disabled]="getUnusedUrlDomains().length === 0" color="accent" label="Additional Basic Auth Config" class="ui-button-secondary">
                    <fa-icon icon="plus"></fa-icon>
                  </button>
                </div>
              </p-accordion-content>
            </p-accordion-panel>
          </p-accordion>
        </div>
      </div>
    }
    <!-- TODO: need proper validation, instead of a long list of disabled-checks which are of course incomplete and non-programmatic -->
    <div class="wm-l-newtest-controls">
      <button (click)="createTest()" [disabled]="!settingsValid() || isCreatingTest" pButton data-testing-id="new-crossbrowsertest-launchBtn">
        {{ data.btnLabel }}
      </button>
    </div>
  </div>
} @else {
  <div class="wm-l-newtest-container-loading">
    <div>
      <p-progressSpinner></p-progressSpinner>
    </div>
    <div>Loading...</div>
  </div>
}
